import * as React from 'react';

import { Spinner } from '@origin-digital/style-guide';
import { Box } from '@origin-digital/layout';

const Loader: React.StatelessComponent<{}> = () => (
  <Box justifyContent="center" alignItems="center" display="flex" height={'100vh'}>
    <Spinner size={96} />
  </Box>
);

export { Loader };
